// @flow
import React from 'react';
import AccountSwitcherListItem from 'app/common/react/components/growth/unauth/signup/AccountSwitcher/AccountSwitcherListItem';
import { type MultipleAccountsUser } from 'app/common/lib/MultipleAccountsUtils';
import { Box, Touchable } from 'gestalt';

type Props = {
  accounts: {
    [key: string]: MultipleAccountsUser,
  },
  onClick: (account: MultipleAccountsUser) => void,
};

const LIST_ITEM_HEIGHT_UNITS = 20;
const GRID_UNIT = 4;

export const BusinessAccountList = (props: Props) => {
  const numAccounts = Object.keys(props.accounts).length;

  return (
    <Box position="relative">
      <Box
        color="lightGray"
        height={numAccounts * LIST_ITEM_HEIGHT_UNITS * GRID_UNIT}
        position="absolute"
        width={1}
        dangerouslySetInlineStyle={{
          __style: {
            bottom: 48,
            left: 52,
          },
        }}
      />
      <ul>
        {Object.keys(props.accounts).map((item: string) => {
          const account = props.accounts[item];

          return (
            <li key={item}>
              <Touchable onTouch={() => props.onClick(account)}>
                <div className="AccountSwitcherListItem" style={{ padding: '8px 16px 8px 28px' }}>
                  <AccountSwitcherListItem account={account} />
                </div>
              </Touchable>
            </li>
          );
        })}
      </ul>
    </Box>
  );
};

export default BusinessAccountList;
